import { useQuery } from '@tanstack/react-query';
import { ITeamType } from '@gettactic/api';

export interface TeamAPI {
  client: {
    teams: {
      all: (params: { type: ITeamType; hidden?: boolean }) => Promise<any>;
    };
  };
}

type Params = {
  api: TeamAPI;
  type: ITeamType | 'no-fetch';
  hidden?: boolean;
};

export function useTeams(params: Params) {
  const {
    data: teamList,
    error,
    isFetching
  } = useQuery({
    queryKey: ['organizations.teamsWithOptions', params.type, params.hidden],

    queryFn: async () => {
      const { type } = params;
      const res = await params.api.client.teams.all({
        ...params,
        type: type as ITeamType
      });
      return res.result;
    },

    enabled: params.type !== 'no-fetch'
  });

  return { teamList, error, isFetching };
}
